module.exports = __webpack_public_path__ + "static/media/logo.08f428e0.svg";